import type { ReactNode } from 'react';
import { Icon, type IconName } from '@core/designsystem';
import type { DocumentKind, DocumentListItem } from './types';

const KIND_ICON: Record<DocumentKind, IconName> = {
  pdf: 'picture_as_pdf',
  photo: 'image',
  other: 'description',
};

/**
 * Строка документа в библиотеке — метрики docs/DESIGN.md, «Строки списков»: высота 68,
 * значок 24, заголовок 16 / 20, подпись 13 / 17.
 *
 * Отдельная от `CaseRow` намеренно: похожи они только внешне, а структура и жесты
 * у них свои. Общая строка на дюжину параметров читалась бы хуже двух честных.
 *
 * Звезда в строке — обязательная альтернатива свайпу (WCAG 2.2, SC 2.5.7): долгое
 * нажатие здесь занято мультивыбором, и другого пути к избранному не остаётся.
 */
export function DocumentRow({
  item,
  selected,
  selectable,
  onOpen,
  onToggleFavorite,
  onMenu,
  handle,
}: {
  item: DocumentListItem;
  selected: boolean;
  /** Экран в режиме мультивыбора: нажатие выделяет, а не открывает. */
  selectable: boolean;
  onOpen: () => void;
  onToggleFavorite: () => void;
  onMenu: () => void;
  handle?: ReactNode;
}) {
  return (
    <div className={`document-row ${selected ? 'document-row--selected' : ''}`}>
      <button
        type="button"
        className="document-row__body"
        onClick={onOpen}
        onContextMenu={(event) => {
          event.preventDefault();
          onMenu();
        }}
      >
        <Icon
          name={selectable && selected ? 'check' : KIND_ICON[item.kind]}
          size={24}
          className="document-row__kind"
        />

        <span className="document-row__texts">
          <span className="document-row__title">{item.title}</span>
          <span className="document-row__meta">
            {item.typeLabel ? `${item.typeLabel} · ${item.meta}` : item.meta}
          </span>
        </span>
      </button>

      {handle ?? (
        <button
          type="button"
          className="document-row__star"
          aria-label={item.isFavorite ? 'Убрать из избранного' : 'В избранное'}
          aria-pressed={item.isFavorite}
          onClick={onToggleFavorite}
        >
          <Icon
            name="star"
            filled={item.isFavorite}
            size={18}
            className={item.isFavorite ? 'document-row__star--on' : undefined}
          />
        </button>
      )}
    </div>
  );
}
